import http from '../api'
import type { APIPaginatedResponse, Filters, Pagination } from '../types'
import { getRequestParamString } from '../utils/utils'
import type { TypeBranch } from '../../types/Branch'

const apiPath = import.meta.env.VITE_API_PATH

async function getBranches(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  return await http.get<APIPaginatedResponse<TypeBranch>>(
    apiPath + 'branches' + getRequestParamString(filters, pagination),
  )
}

export default {
  getBranches,
}
